<template>
    <div class="pagination">
        <b-pagination
            :value="value"
            :total-rows="totalNumberOfRows"
            :per-page="rowsPagePage"
            limit="20"
            @input="$emit('input', $event)"
            hide-goto-end-buttons
        />
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({})
export default class LelyPagination extends Vue {
    @Prop({
        required: true,
        type: Number,
    })
    value!: number;

    @Prop({
        required: true,
        type: Number,
    })
    totalNumberOfRows!: number;

    @Prop({
        required: true,
        type: Number,
    })
    rowsPagePage!: number;
}
</script>

<style lang="scss">
.pagination {
    gap: 3px;

    .page-item {
        margin: 0;

        .page-link {
            padding: 0.375rem 0.75rem !important;
            height: auto !important;
            border: 1px solid #dee2e6 !important;
            text-decoration: none !important;
        }

        &.disabled {
            .page-link {
                color: #ccc;
                pointer-events: none !important;
                border-color: #dee2e6 !important;
            }
        }
    }
}
</style>
